var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.63672,
    cy: 9.5,
    r: 7.5,
    fill: "#D43939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67627 5.89628C7.67627 5.58205 7.81625 5.33638 8.04956 5.24496C8.2537 5.16498 9.00611 5.18212 9.22192 5.26782C9.35024 5.32495 9.46106 5.42208 9.51939 5.55348C9.61271 5.73631 9.60688 5.902 9.44356 8.35873L9.28417 10.7319C9.27411 10.8816 9.21063 11.0228 9.10527 11.1297C8.77864 11.4611 8.22454 11.3925 8.06122 10.9983C7.9854 10.8326 7.67627 6.66758 7.67627 5.89628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58955 12.099C8.11652 12.099 7.73306 12.4824 7.73306 12.9555C7.73306 13.4285 8.11652 13.812 8.58955 13.812H8.62532C9.09835 13.812 9.48181 13.4285 9.48181 12.9555C9.48181 12.4824 9.09835 12.099 8.62532 12.099H8.58955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.1c087fb16d93b3fc616cdb87fd3abebf.svg";
export { ForwardRef as ReactComponent };